import type Konva from 'konva';
import type { BoardObject } from '../interfaces/board-object.interface.js';

/**
 * Write a BoardObject's base geometry — position, size and rotation — onto its
 * Konva node. This is the SINGLE place that maps `BoardState` geometry to the
 * canvas, so every kind of move (mouse-drag commit, arrow-key nudge, undo/redo,
 * programmatic update) is uniform across all object types.
 *
 * Every slice's top-level node — `Konva.Group` (sticky, textbox, line, ellipse,
 * person, checkbox, image, smiley) or `Konva.Rect` (rectangle) — carries the
 * object's bounding box as its own `{x, y, width, height, rotation}` attributes;
 * inner shapes use local coordinates. So this helper is type-agnostic: it sets
 * the four geometry attributes and leaves the slice's `updateNode` to refresh
 * the inner, type-specific visuals (fill, radii, text, caps, …).
 *
 * Coordinates are world-space floats and applied verbatim — fractional values
 * (e.g. a zoom-relative 0.5 px nudge at 200%) are preserved; Konva renders
 * sub-pixel.
 */
export function applyBaseGeometry(node: Konva.Node, obj: BoardObject): void {
  node.setAttrs({
    x: obj.x,
    y: obj.y,
    width: obj.width,
    height: obj.height,
    rotation: obj.rotation,
  });
}
